const root = document.querySelector('[data-rfp]');
if (root) {
  const form = root.querySelector('[data-rfp-form]');
  const variants = JSON.parse(root.querySelector('[data-rfp-variants]').textContent);
  const gallery = root.querySelector('[data-rfp-gallery]');
  const media = [...gallery.children];
  const pictures = [...gallery.querySelectorAll('[data-rfp-image]')];
  const dots = [...root.querySelectorAll('[data-rfp-dot]')];
  const dialog = document.querySelector('[data-rfp-dialog]');
  const zoom = dialog.querySelector('[data-rfp-zoom-image]');
  const button = form.querySelector('[type=submit]');
  const status = form.querySelector('[data-rfp-status]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const narrowGallery = matchMedia('(max-width:989px)');
  let galleryIndex = 0, galleryWidth = gallery.clientWidth, galleryIsNarrow = narrowGallery.matches;
  root.classList.add('rfp-enhanced');
  let active = 0, previousFocus, previousOverflow, pending = false;
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD',minimumFractionDigits:amount % 100 ? 2 : 0}).format(amount / 100);
  function show(index) {
    if (!pictures.length) return;
    active = (index + pictures.length) % pictures.length;
    const picture = pictures[active];
    zoom.src = picture.dataset.full;
    zoom.alt = picture.querySelector('img')?.alt || root.querySelector('h1').textContent;
    dialog.classList.remove('is-zoomed');
    dialog.querySelector('[data-rfp-counter]').textContent = `${active + 1} / ${pictures.length}`;
    dialog.querySelector('[data-rfp-prev]').hidden = pictures.length < 2;
    dialog.querySelector('[data-rfp-next]').hidden = pictures.length < 2;
  }
  pictures.forEach((picture,index)=>picture.addEventListener('click',()=>{
    previousFocus = picture;previousOverflow = document.body.style.overflow;
    show(index);dialog.showModal();document.body.style.overflow='hidden';
  }));
  dialog.querySelector('[data-rfp-close]').addEventListener('click',()=>dialog.close());
  dialog.querySelector('[data-rfp-prev]').addEventListener('click',()=>show(active-1));
  dialog.querySelector('[data-rfp-next]').addEventListener('click',()=>show(active+1));
  dialog.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'){event.preventDefault();show(active+1);}
    if(event.key==='ArrowLeft'){event.preventDefault();show(active-1);}
  });
  dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow || '';previousFocus?.focus({preventScroll:true});});
  zoom.addEventListener('click',()=>dialog.classList.toggle('is-zoomed'));
  function selectImage(index, initial=false){
    galleryIndex=Math.max(0,Math.min(media.length-1,index));
    media.forEach((item,i)=>item.toggleAttribute('data-rfp-active-media',i===galleryIndex));
    dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===galleryIndex)));
    if(narrowGallery.matches)gallery.scrollTo({left:gallery.clientWidth*galleryIndex,behavior:reduced||initial?'instant':'smooth'});
  }
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>selectImage(index)));
  let frame;
  gallery.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
    if(!narrowGallery.matches||galleryIsNarrow!==narrowGallery.matches||galleryWidth!==gallery.clientWidth)return;
    const index=Math.round(gallery.scrollLeft/gallery.clientWidth);
    galleryIndex=Math.max(0,Math.min(media.length-1,index));
    media.forEach((item,i)=>item.toggleAttribute('data-rfp-active-media',i===galleryIndex));
    dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
    media.forEach((item,i)=>{if(i!==index)item.querySelector('video')?.pause();});
  });},{passive:true});
  gallery.addEventListener('keydown',event=>{
    if(!narrowGallery.matches||!['ArrowRight','ArrowLeft'].includes(event.key))return;
    event.preventDefault();const i=Math.round(gallery.scrollLeft/gallery.clientWidth);
    selectImage(Math.max(0,Math.min(media.length-1,i+(event.key==='ArrowRight'?1:-1))));
  });
  new ResizeObserver(()=>{
    if(galleryWidth===gallery.clientWidth&&galleryIsNarrow===narrowGallery.matches)return;
    cancelAnimationFrame(frame);
    selectImage(galleryIndex,true);
    galleryWidth=gallery.clientWidth;galleryIsNarrow=narrowGallery.matches;
  }).observe(gallery);
  root.querySelector('[data-rfp-size]')?.addEventListener('click',()=>{root.querySelector('[data-rfp-specs]').open=true;});
  function selected(){return variants.find(v=>String(v.id)===form.querySelector('[data-rfp-variant]').value);}
  button.disabled=!selected()?.available;
  button.textContent=selected()?.available?root.dataset.addLabel:root.dataset.soldLabel;
  const initialIndex=media.findIndex(item=>String(item.dataset.mediaId)===String(selected()?.featured_media?.id));
  if(initialIndex>=0)selectImage(initialIndex,true);
  form.querySelectorAll('[data-rfp-option] input').forEach(input=>input.addEventListener('change',()=>{
    const values=[...form.querySelectorAll('[data-rfp-option]')].map(group=>group.querySelector('input:checked')?.value);
    const variant=variants.find(v=>v.options.every((value,i)=>value===values[i]));
    form.querySelector('[data-rfp-variant]').value=variant?.id || '';
    button.disabled=!variant?.available||pending;
    button.textContent=variant?(variant.available?root.dataset.addLabel:root.dataset.soldLabel):root.dataset.unavailableLabel;
    status.hidden=true;
    root.querySelectorAll('[data-rfp-spec-option]').forEach(el=>{el.textContent=values[Number(el.dataset.rfpSpecOption)] || '';});
    if(!variant)return;
    root.querySelector('[data-rfp-price]').textContent=money(variant.price);
    const compare=root.querySelector('[data-rfp-compare]');compare.hidden=!(variant.compare_at_price>variant.price);compare.textContent=variant.compare_at_price?money(variant.compare_at_price):'';
    root.querySelector('[data-rfp-sku]').textContent=variant.sku || '';root.querySelector('[data-rfp-sku-row]').hidden=!variant.sku;
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    const index=media.findIndex(item=>String(item.dataset.mediaId)===String(variant.featured_media?.id));
    if(index>=0)selectImage(index);
  }));
  form.addEventListener('submit',async event=>{
    event.preventDefault();
    if(pending||!selected()?.available)return;
    pending=true;button.disabled=true;button.textContent=root.dataset.loadingLabel;status.hidden=true;status.removeAttribute('data-error');
    let accepted=false;
    try{
      const drawer=document.querySelector('[data-cart-drawer]');
      const data=new FormData(form);data.set('sections','cart-drawer');data.set('sections_url',location.pathname);
      const response=await fetch(drawer.dataset.cartAddUrl,{method:'POST',headers:{Accept:'application/json'},body:data});
      const payload=await response.json();
      if(!response.ok)throw new Error(payload.description || root.dataset.errorLabel);
      accepted=true;
      const parsed=document.createElement('template');parsed.innerHTML=payload.sections?.['cart-drawer'] || '';
      const next=parsed.content.querySelector('[data-cart-drawer]');
      if(next){
        drawer.replaceWith(next);
        document.querySelectorAll('.site-header__cart span').forEach(el=>{el.textContent=next.dataset.cartCount;el.classList.toggle('rf-empty-count',Number(next.dataset.cartCount)===0);});
        document.querySelector('[data-cart-drawer-open]')?.click();
      }else{location.assign(drawer.dataset.cartUrl);}
      status.textContent=root.dataset.addedLabel;status.hidden=false;
    }catch(error){
      status.textContent=accepted?root.dataset.addedLabel:(error.message || root.dataset.errorLabel);
      status.toggleAttribute('data-error',!accepted);status.hidden=false;
    }finally{pending=false;button.disabled=!selected()?.available;button.textContent=selected()?.available?root.dataset.addLabel:root.dataset.soldLabel;}
  });
}
